import { getLocale } from '@/ui/i18n/i18n';

const APP_ID = process.env.VUE_APP_INTERCOM_APPID;
const { Intercom } = window;

/**
 * be aware that boot() changes window object
 */
export function boot() {
  window.Intercom('boot', {
    app_id: APP_ID,
    //Website visitor so may not have any user related info, add here if required
    language_override: getLocale(),
  });
}

/**
 * be aware that all methods below must
 *  be run after boot
 *  be run on window.* because window changed after boot
 */

export function startTour(tourId) {
  window.Intercom('startTour', tourId);
}

export default Intercom;
